// Локальные форматтеры для recordings/audio-recaps (длительность HH:MM:SS, MM:SS).
// Даты сущностей — через `@/lib/format` / `EntityTimestamp`.

import { formatEntityAbsoluteDate, formatEntityTimestamp } from "@/lib/format";

export function formatDurationHms(totalSec: number): string {
	const s = Math.max(0, Math.floor(totalSec));
	const h = Math.floor(s / 3600);
	const m = Math.floor((s % 3600) / 60);
	const sec = s % 60;
	const mm = m.toString().padStart(2, "0");
	const ss = sec.toString().padStart(2, "0");
	if (h > 0) return `${h}:${mm}:${ss}`;
	return `${mm}:${ss}`;
}

/**
 * @deprecated Используйте `formatEntityTimestamp` / `<EntityTimestamp />`.
 * Тонкая обёртка для совместимости; `labels` игнорируются.
 */
export function formatDateRelative(
	iso: string,
	locale: string,
	_labels?: { today: string; yesterday: string; daysAgo: (n: number) => string },
): string {
	void _labels;
	return formatEntityTimestamp(iso, locale);
}

/**
 * @deprecated Используйте `formatEntityAbsoluteDate` / `<EntityTimestamp />`.
 */
export function formatDateAbsolute(iso: string, locale?: string): string {
	const resolved = locale ?? (typeof navigator !== "undefined" ? navigator.language : "en");
	return formatEntityAbsoluteDate(iso, resolved);
}
